module.exports = {
      id: "ios-small-usage",
      viewBox: "0 0 448 512",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#ios-small",
      toString: function () {
        return this.url;
      }
    }